<template>
    <div class="list_card animated fadeIn" :class="{'active':little}">
        <a :href="UrlString" class="img">
            <img :src="event.Image || require('@/assets/default-big.png')" />
        </a>
        <a :href="UrlString" class="content">
            <div class="category">{{categoryId?categoryId:CategoryName}}</div>
            <div class="title">{{event.Title}}</div>
            <div class="left_box">
                <div class="left_box_span" v-if="event.RegisterStartOn">
                    <div class="icon icon-calendar"></div>
                    <span>{{RegisterDate}}</span>
                </div>
                <div class="left_box_span">
                    <div class="icon icon-place"></div>
                    <span>{{event.Location}}</span>
                </div>
                <div class="left_box_span" v-if="event.Organizer">
                    <div class="icon icon-organizer-1"></div>
                    <span>主辦單位:{{event.Organizer}}</span>
                </div>
            </div>
        </a>
    </div>
</template>

<script>
export default {
    name: "listcard",
    components: {},
    props: {
        event: {
            type: Object
        },
        categoryId: {
            type: String
        },
        categoryList: {
            type: Array
        },
        little: false //true變為手機板
    },
    data() {
        return {
            CategoryData: []
        };
    },
    methods: {
        reload() {
            location.reload();
        }
    },
    computed: {
        UrlString() {
            const vm = this;
            // if (vm.event.RequireRegister) {
            //     return `/Event/Index?Id=${vm.event.Id}`;
            // } else {
            //     return `/Academic/Activity?Id=${vm.event.Id}`;
            // }
            return `/Academic/Activity?Id=${vm.event.Id}`;
        },
        RegisterDate() {
            const vm = this;
            let Start = vm
                .$moment(vm.event.RegisterStartOn)
                .format("YYYY-MM-DD");
            let End = vm.$moment(vm.event.RegisterEndOn).format("YYYY-MM-DD");
            return Start + "~" + End;
        },
        CategoryName() {
            const vm = this;
            let CategoryName = "";
            vm.categoryList.forEach(item => {
                if (item.Id == vm.event.CategoryId) {
                    CategoryName = item.Title;
                }
            });
            return CategoryName;
        }
    },
    created() {},
    mounted() {},
    watch: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.list_card {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin-bottom: 10px;
    /* padding-top: 10px; */
    letter-spacing: 2px;
    line-height: 1.5;
    word-break: break-all;
}
.list_card + .list_card {
    /* border-top: 1px solid #ccc; */
}
.list_card .img {
    width: 23%;
    overflow: hidden;
    /* border-radius: 5px; */
    /* display: inline-block; */
    display: flex;
    align-items: center;
    justify-content: center;
    height: 240px;
    text-align: center;
    background-color: #fff;
}
.list_card .img img {
    width: 100%;
    max-height: 100%;
}
.list_card .content {
    width: 75%;
    padding: 20px;
    background-color: #fff;
    display: flex;
    flex-wrap: wrap;
    text-decoration: none;
    align-items: flex-start;
}
.list_card .content .category {
    font-size: 0.9rem;
    color: #666;
    margin-bottom: 5px;
    width: 100%;
    padding: 5px 0;
}
.list_card .content .title {
    font-size: 1.5rem;
    padding: 10px 0;
    width: 100%;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    margin-bottom: 5px;
    line-height: 1.5;
    color: #333;
}
.list_card .content .left_box {
    display: inline-flex;
    flex-wrap: wrap;
    flex-direction: column;
    width: 80%;
}
.list_card .content .left_box .left_box_span {
    display: flex;
    /* flex-wrap: wrap; */
    align-items: flex-start;
    font-size: 1rem;
    color: #666;
    padding: 5px 0;
}
.list_card .content .left_box .left_box_span > div:nth-child(1) {
    padding-right: 8px;
}

.list_card .content .right_box {
    width: 20%;
    display: inline-flex;
    /* justify-content: center; */
    color: #333;
    align-items: center;
    flex-wrap: wrap;
}
.list_card .content .right_box > div {
    width: 100%;
    text-align: center;
    line-height: 1.5;
}
/* little 為true 的CSS */
.list_card.active .img {
    display: none;
}
.list_card.active .content {
    width: 100%;
    padding: 20px 10px;
}
.list_card.active .content .title {
    font-size: 1.1rem;
    line-height: 1.2;
}

.list_card.active .content .left_box {
    width: 100%;
}
.list_card.active .content .left_box .left_box_span {
    line-height: 1.5;
    font-size: 14px;
}
.list_card.active .content .right_box {
    width: 100%;
    margin: auto;
    text-align: center;
    display: none;
}
@media screen and (max-width: 767px) {
    .list_card .img {
        display: none;
    }
    .list_card .content {
        width: 100%;
    }
    .list_card .content .title {
        font-size: 1.2rem;
        line-height: 1.2;
    }

    .list_card .content .left_box {
        width: 100%;
    }
    .list_card .content .left_box .left_box_span {
        line-height: 1.5;
    }
    .list_card .content .right_box {
        width: 100%;
        margin: auto;
        text-align: center;
        display: none;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/listCard/index.vue